import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Link } from 'react-router'
import propTypes from 'prop-types'
import { translate } from 'react-i18next'
import { setSelectedItem, accessMenus } from '../../../actions/menu'
import MenuIcons from 'component/layouts/newMenu/MenuIcons'
import ArrowRight from 'images/arrow-menu.svg'

const MenuTrigger = ({ open, onClick, t }) => (
  <div
    onClick={() => {
      onClick && onClick()
    }}
    className='menu-trigger-hover'
  >
    <div className='menu-trigger-container'>
      <div
        className={`menu-trigger-slices ${
          open ? 'menu-trigger-open' : 'menu-trigger-closed'
        }`}
      >
        <div className='slice slice-1' />
        <div className='slice slice-2' />
        <div className='slice slice-3' />
      </div>
      <span className={`open-menu-tooltip ${open && 'hide-tooltip'}`}>
        Abrir menu
      </span>
    </div>
    <h4>{t('close.menu')}</h4>
  </div>
)

MenuTrigger.propTypes = {
  open: propTypes.bool,
  onClick: propTypes.func,
  t: propTypes.func,
}

const MenuItem = (props) => {
  const {
    menu,
    t,
    isOpen,
    setSelectedItem,
    selectedMenu,
    overflowingMenus,
    scrollPos,
    accessMenus,
    user,
  } = props

  const sidebarHoverClassNames = [
    'sidebar-floating-menu',
    isOpen && 'extra-width',
    (overflowingMenus.includes(menu.cdMenu) && 'invert-overflow') ||
      'arrow-on-top',
  ].join(' ')

  const linkClick = (menu, subItem) => {
    if (setSelectedItem) {
      setSelectedItem({ cdMenu: menu.cdMenu, cdSubItem: subItem.cdMenu })
    }
    accessMenus(user, subItem.cdMenu)
  }

  return (
    <>
      <div className='sidebar-item'>
        <div
          className={`${'icon-with-title'} ${
            !isOpen && 'icon-with-title-closed'
          }`}
        >
          <i
            className={`${isOpen ? 'remove-right-border' : ''} ${
              selectedMenu.cdMenu === menu.cdMenu ? 'selected' : ''
            }`}
          >
            {MenuIcons[menu.cdMenu] ? MenuIcons[menu.cdMenu] : ''}
          </i>
          <div
            className={`title-with-arrow ${isOpen && 'has-hover'} ${
              selectedMenu.cdMenu === menu.cdMenu && isOpen && 'selected'
            }`}
          >
            <h4>{t(menu.dsChaveMenu)}</h4>
            <svg viewBox='0 0 532.157 532.157' className='arrow-menu'>
              <use xlinkHref={`${ArrowRight}#icon-arrow-menu`} />
            </svg>
          </div>
        </div>
        <div
          id={menu.cdMenu}
          style={{
            transform: overflowingMenus.includes(menu.cdMenu)
              ? `translateY(calc( -100% + 3rem - ${scrollPos}px ))`
              : `translateY(-${scrollPos}px)`,
          }}
          className={sidebarHoverClassNames}
        >
          <h4>{t(menu.dsChaveMenu)}</h4>
          <hr />

          <div className='ghost-select-div' />
          <div className='arrow-left' />
          <div className='scroll-container'>
            {menu.subItems &&
              menu.subItems.map((subItem) => (
                <Link
                  key={subItem.cdMenu}
                  onClick={() => linkClick(menu, subItem)}
                  className={`menu-subitem-link ${
                    selectedMenu.cdSubItem === subItem.cdMenu && 'selected'
                  }`}
                  to={
                    subItem.dsView && subItem.dsView.startsWith('/')
                      ? subItem.dsView
                      : `/${subItem.dsView}`
                  }
                >
                  {t(subItem.dsChaveMenu)}
                </Link>
              ))}
          </div>
        </div>
      </div>
    </>
  )
}

MenuItem.propTypes = {
  menu: propTypes.object,
  t: propTypes.func,
  isOpen: propTypes.bool,
  selectedMenu: propTypes.object,
  setSelectedItem: propTypes.func,
  hideMenus: propTypes.bool,
  overflowingMenus: propTypes.array,
  scrollPos: propTypes.number,
  accessMenus: propTypes.func,
  user: propTypes.object.isRequired,
}

class Sidebar extends Component {
  constructor(props) {
    super(props)
    this.state = {
      fullMenuOpen: false,
      hideMenus: false,
      overflowingMenus: [],
      scrollBarPos: 0,
    }
  }

  componentDidMount() {
    // then hide the menus, and save it to the state, to set the proper invert classes
    this.setState({
      hideMenus: true,
    })

    window.addEventListener('resize', () => {
      this.getSidebarPos()
    })

    setTimeout(() => {
      this.getSidebarPos()
    }, 100)
  }

  // function to get current sidebar position, and move the menus with it
  getSidebarPos = () => {
    const elementPos = document
      .getElementById('menu-trigger')
      .getBoundingClientRect()
    this.setState({ scrollBarPos: Math.abs(elementPos.y - 20) })

    const overflowingCds = []

    const menus = document.querySelectorAll('.sidebar-floating-menu')
    let c = 0

    for (const el of menus) {
      const id = el.getAttribute('id')
      if (c >= 3) {
        const rect = el.getBoundingClientRect()
        const rectParent = el.parentElement.getBoundingClientRect()
        if (rectParent.y + rect.height + 30 > window.innerHeight) {
          overflowingCds.push(parseInt(id, 10))
        }
      }
      c++
    }

    this.setState({ overflowingMenus: overflowingCds })
  }

  render() {
    const { menu, t, setSelectedItem, selectedMenu, accessMenus, user } =
      this.props
    const { fullMenuOpen, hideMenus, overflowingMenus, scrollBarPos } =
      this.state
    const menuClassNames = [
      'sidebar-menu',
      `sidebar-menu-${fullMenuOpen ? 'open' : 'closed'}`,
    ].join(' ')

    return (
      <>
        <div
          onClick={() => this.setState({ fullMenuOpen: false })}
          className={`backdrop-menu ${fullMenuOpen && 'backdrop-menu-open'}`}
        />
        <div className={menuClassNames} onScroll={() => this.getSidebarPos()}>
          <div id={'menu-trigger'} className='menu-trigger-title'>
            <MenuTrigger
              t={t}
              open={fullMenuOpen}
              onClick={() => this.setState({ fullMenuOpen: !fullMenuOpen })}
            />
          </div>
          <div className='menu-icons'>
            {((menu && Object.values(menu)) || []).map((menuItem) => (
              <MenuItem
                key={menuItem.cdMenu}
                accessMenus={accessMenus}
                user={user}
                scrollPos={scrollBarPos}
                overflowingMenus={overflowingMenus}
                hideMenus={hideMenus}
                setSelectedItem={setSelectedItem}
                selectedMenu={selectedMenu}
                isOpen={fullMenuOpen}
                menu={menuItem}
                t={t}
              />
            ))}
          </div>
        </div>
      </>
    )
  }
}

Sidebar.propTypes = {
  menu: propTypes.object,
  t: propTypes.func,
  setSelectedItem: propTypes.func,
  selectedMenu: propTypes.object,
  accessMenus: propTypes.func,
  user: propTypes.object.isRequired,
}

const SidebarTranslated = translate(null, {
  wait: true,
  translateFuncName: 't',
})(Sidebar)

const mapStateToProps = (state) => ({
  menu: state.menuReducer.menu,
  selectedMenu: state.menuReducer.selectedMenu,
})

export const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ setSelectedItem, accessMenus }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(SidebarTranslated)
